<template>
    <div style="margin-left:50px;">
  
            <el-form style="display: flex;flex-wrap: wrap;">
                <el-form-item label="候选人姓名:" style="display: flex;width: 33%;">
                    <el-input v-model="input1" type="text"  placeholder="请输入候选人姓名"></el-input>
                    <!-- <el-select placeholder="请选择添加人" v-model="input1" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select> -->
                </el-form-item>

                <!-- <el-form-item label="添加时间:" style="display: flex;width: 33%;" >
                    <el-date-picker style="width: 100%"  v-model="input2" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" clearable></el-date-picker>
                </el-form-item> -->

                <el-form-item label="是否住宿:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择是否住宿" v-model="input3" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="offer状态:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择offer状态" v-model="input4" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList3"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="科目:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择科目" v-model="input5" style="width: 100%" clearable  multiple filterable>
                        <el-option   v-for="item in optionList4"  :key="item.id"  :value="item.id" :label="item.categoryName"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="岗位:" style="display: flex;width: 33%;" >
                    <el-select style="width: 100%" v-model="input6" >
                        <!-- <el-option hidden :value="input6"> </el-option>
                          <el-tree :data="dataTrees" :props="defaultPropss" node-key="deptId" ref="belongingTree"   :highlight-current="true" :check-on-click-node="true" @check="handleTreeCheck1">
                        </el-tree> -->
                         <el-option   v-for="item in optionList333"  :key="item.dictType"  :value="item.dictType" :label="item.dictValue"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="提交人:" style="display: flex;width: 33%;" >
                    <el-select placeholder="请选择提交人" v-model="input55" style="width: 100%" clearable filterable>
                        <el-option   v-for="item in optionList5"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="手机号:" style="display: flex;width: 33%;">
                    <el-input @input="input7 = $event.replace(/\D/g, '')"  v-model="input7" type="text"  placeholder="请输入手机号"></el-input>
                </el-form-item>

                
                <el-form-item label="邮箱:" style="display: flex;width: 33%;">
                    <el-input v-model="input8" type="text"  placeholder="请输入邮箱"></el-input>
                </el-form-item>

                <el-form-item label="报道日期:"   style="display: flex;width: 33%;" >
                    <el-date-picker style="width: 100%"  v-model="input9" type="daterange" value-format="yyyy-MM-dd" range-separator="至"   start-placeholder="开始日期"   end-placeholder="结束日期" clearable></el-date-picker>
                </el-form-item>

                <el-form-item label="所属城市:" style="display: flex;width: 33%;" >
                    <el-select v-model="input10" clearable filterable placeholder="请选择所属城市" style="width: 100%">
                        <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                        :value="item.dictType"></el-option>
                    </el-select>
                </el-form-item>


                <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
                    <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus" @click="AddexportBtnss">添加模版</el-button> -->
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                    <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                </div>

            </el-form>


            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
                <el-table-column prop="name" label="候选人姓名"></el-table-column>
                <!-- <el-table-column prop="deptName" label="offer岗位"></el-table-column> -->
                <el-table-column prop="postTypeName" label="岗位"></el-table-column>
                <el-table-column prop="telPhone" label="手机号"></el-table-column>
                <el-table-column prop="email" label="邮箱"></el-table-column>
                <el-table-column prop="reportTime" label="报道日期"></el-table-column>
                <el-table-column prop="categoryNames" show-overflow-tooltip label="科目">
                    <template slot-scope="scope">
                        <span>{{ scope.row.categoryNames.join(',') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isStay" label="是否住宿">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isStay === 1">否</span>
                        <span v-if="scope.row.isStay === 2">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="regionName" label="所在地域" width="100">
                    <!-- <template slot-scope="scope">
                        <span v-if="scope.row.regionName === 1">北京</span>
                        <span v-if="scope.row.regionName === 2">深圳</span>
                        <span v-if="scope.row.regionName === '1'">北京</span>
                        <span v-if="scope.row.regionName === '2'">深圳</span>
                    </template> -->
                </el-table-column>
                <el-table-column prop="noteUrl" label="简历附件">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-around;">
                            <span style="color:#3aabe3;"  @click="handleClickView('查看', scope.row)">可查看</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="offerStatus" label="offer状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.offerStatus === 0">待入职</span>
                        <span v-if="scope.row.offerStatus === 1">拒绝offer</span>
                        <span v-if="scope.row.offerStatus === 2">已入职</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createName" show-overflow-tooltip label="提交人"></el-table-column>
                <el-table-column prop="sendDate" label="发放时间"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: space-around;">
                            <el-button type="text" size="small"   @click="handleClickView('编辑', scope.row)">编辑</el-button>
                            <el-button type="text" size="small"   @click="handleClickView('补发', scope.row)">补发</el-button>
                            <el-button type="text" size="small"   @click="handleClickView('详情', scope.row)">详情</el-button>
                        </div>
                    </template>
                </el-table-column>
                
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageNum" :page-size="pageSize"
                layout="prev, pager, next,sizes, jumper" :total="total">
            </el-pagination>






        <div class="box"  v-if="ShowAddTemplateDialog">
        
            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;">
                <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowAddTemplateDialogClose"><i class="el-icon-close"></i> </div>
                <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">{{ShowAddTemplateDialogTltie}}</div>
            </div>

            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;height:82vh;display: flex;">
               <div style="width:20%;border-right: 2px solid #EBEEF5;overflow-y: auto;">
                    <div style="margin-top: 10px;padding-top: 10px;"><el-button style="width: 80%;height: 35px;line-height: 2px;" type="primary" plain @click="handleAddCilckTemplate('邮箱模版')">邮箱模版</el-button></div>
               </div>
               <div style="width:80%;">

               </div>
            </div>

            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding: 10px 0px;display: flex;justify-content: end; padding-right: 25px;">
                <span slot="footer" class="dialog-footer">
                    <el-button size="small"  @click="handleShowAddTemplateDialogClose">取 消</el-button>
                    <el-button size="small"  type="primary" @click="handleShowAddTemplateDialogSub">确 定</el-button>
                </span>
            </div>

        </div>   


        <div class="box"  v-if="ShowCurrentComponentDialog">
            <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding-bottom: 6px;">
                <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowCurrentComponentDialogClose"><i class="el-icon-close"></i> </div>
                <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">{{ currentComponent === 'followUpComponents' ? 'offer基本信息' : currentComponent === 'grantComponents' ? 'offer发放' : '入职填报' }}</div>
            </div>
            <div>
                <component :is="currentComponent" @handleEventChildren="handleEventChildren" :resumesId="resumesId" :initObj="initObj" :newid="ids" :types="types"></component>
            </div>
        </div>



        <el-dialog title="预览简历" width="50%" style="padding: 0px 50px;" :visible.sync="showInfo" :before-close="showshowInfoViewInfoCler" :close-on-click-modal="false">
           <Guciya v-if="showInfo" :url="urls"></Guciya>
        </el-dialog>

        <el-dialog title="预览简历" width="60%" style="padding: 0px 50px;" :visible.sync="showInfos" :before-close="showshowInfoViewInfoClers" :close-on-click-modal="false">
            <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload" class="mr10"> 下 载</el-button>
            <GuciYa-VueOfficeDocx :src="docxContent" ref="docxEditor" :options="editorOptions"></GuciYa-VueOfficeDocx>
        </el-dialog>

        <el-dialog title="预览简历" width="60%" style="padding: 0px 50px;" :visible.sync="showImgDing" :before-close="showImgDingClers5" :close-on-click-modal="false">
            <div style="margin-bottom: 20px;">
                <el-button :theme="'default'"  type="submit" :title="'基础按钮'" @click.stop="handleDownload1" class="mr10"> 下 载</el-button>
            </div>
            <div>
                <img :src="showImgDingurlsss" :alt="showImgDingurlsss" style="width: 100%;">
            </div>
        </el-dialog>

       
    </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import grantComponents from "./components/grantComponents";
import employmentComponents from "./components/employmentComponents";
import Guciya from "./components/Guciya-compoents";
import { getSubject } from "@/api/fiveClassApi"
import followUpComponents from "./components/followUpComponents";
export default {
    components: { grantComponents, employmentComponents, Guciya, followUpComponents },
    data(){
        return{ 

            editorOptions: {
                toolbar: true,
                width: '800px',
                height: '600px'
            },
            showInfos:false,
            docxContent: '',

            showInfo:false,
            urls:'',

            ids:'',

            optionList333: [
               
            ],

            ShowCurrentComponentDialog: false,

            input1: '',
            input2: '',
            input3: '',
            input4: '',
            optionList1: [],
            optionList2: [{id:1,realname:'否'},{id:2,realname:'是'}],
            optionList3: [{id:0,realname:'待入职'},{id:1,realname:'拒绝offer'},{id:2,realname:'已入职'}],

            pageNum: 1,
            pageSize: 10,
            total: 0,

            dataList: [],


            ShowAddTemplateDialog: false,
            ShowAddTemplateDialogTltie: '添加模版',

            currentComponent:'',

            resumesId:'',
            initObj: null,
            types:'',
            input5:'',
            optionList4:[],

            dataTrees:[],
            defaultPropss:{ children: 'children', label: 'deptName' },

            input6 :'',
            input7 :'',
            input8 :'',
            input9: [],
            input10:'',

            input6Id:'',

            showImgDing: false,
            showImgDingurlsss:'',

            optionsListt:[
                {dictValue:"北京", dictType:1 },
                {dictValue:"深圳", dictType:2 },
            ],

            input55:'',
            optionList5: [],

        }
    },

    mounted(){

        
        axios.post(`${apiBaseUrl}/people/getCommit`,{}, {headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
           this.optionList5 = res.data.data.data
        })


        this.optionList333 = JSON.parse(sessionStorage.getItem('positionList'))
        this.handleGetApiAll()

        axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
        { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
        }).then((res)=>{ this.optionsListt = res.data.data})

    },


    methods:{

        handleDownload1(){
            let ele = document.createElement('a')
            ele.setAttribute('href', this.showImgDingurlsss)
            document.body.appendChild(ele)
            ele.click()
        },

        showImgDingClers5(){
            this.showImgDing = false
            this.showImgDingurlsss = ''
        },

        showshowInfoViewInfoClers(){
            this.showInfos = false
        },

        handleDownload(){
            let ele = document.createElement('a')
            ele.setAttribute('href', this.docxContent)
            document.body.appendChild(ele)
            ele.click()
        },

        showshowInfoViewInfoCler(){
            this.showInfo = false
        },


        handleEventChildren(event){
            this.currentComponent = ''
            this.ShowCurrentComponentDialog = event
            this.handleGeiApiFindOfferPage()
        },

        handleShowCurrentComponentDialogClose(){
            this.currentComponent = ''
            this.ShowCurrentComponentDialog = false
        },


        handleGetApiAll(){
            axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
               this.optionList1 = res.data.data
            //    this.optionList2 = res.data.data
            //    this.optionList3 = res.data.data
            })

            axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})

            this.handleGeiApiFindOfferPage()
            getSubject().then(res => {    this.optionList4 = res.data })
        },



        exportBtns(){
            let data = {
                 pageNum: this.pageNum,  
                 pageSize: this.pageSize, 
                 name: this.input1, 
                 isStay: this.input3, 
                 offerStatus: this.input4,  
                 categoryIdList: this.input5 ? this.input5 : [] , 
                 deptId: this.input6Id,
                 telPhone: this.input7,
                 email: this.input8,
                 reportStartTime: this.input9.length > 0 ? this.input9[0] : '',
                 reportEndTime: this.input9.length > 0 ? this.input9[1] : '',
                 regionName: this.input10 ||  localStorage.getItem('cityTepy'),
                 postType: this.input6 || '',
                 createId: this.input55,
            }
            axios.post(`${apiBaseUrl}/resumes-offer/exportResumesOffer`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
                    const downloadLink = document.createElement("a")
                    downloadLink.href = URL.createObjectURL(blob)
                    downloadLink.download = "offer跟进.xlsx"
                    downloadLink.click()
                    this.$message({ message:'导出成功', type: "success" });
                } else{
                    this.$message.error('导出失败')
                }
            }).catch((err) => {
                this.$message.error(err)
            })
        },

        
        handleGeiApiFindOfferPage(){
            let data = { 
                 pageNum: this.pageNum,  
                 pageSize: this.pageSize, 
                 name: this.input1, 
                 isStay: this.input3, 
                 offerStatus: this.input4,  
                 categoryIdList: this.input5 ? this.input5 : [] , 
                 deptId: this.input6Id,
                 telPhone: this.input7,
                 email: this.input8,
                 reportStartTime: this.input9.length > 0 ? this.input9[0] : '',
                 reportEndTime: this.input9.length > 0 ? this.input9[1] : '',
                 regionName: this.input10 ||  localStorage.getItem('cityTepy'),
                 postType: this.input6 || '',
                 createId: this.input55,
                }
            axios.post(`${apiBaseUrl}/resumes-offer/findOfferPage`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){

                    let data = res.data.data
                    this.dataList = data.records
                    this.total = data.total
                    this.pageSize = data.size
                    this.pageNum = data.current

                    this.$message({type: 'success', message: '查询成功'})
               }else{
                    this.$message({type: 'error', message: '查询失败' })
               }
            })
        },

        handleAddCilckTemplate(type){
            if(type === '邮箱模版'){
                
            }
        },

        AddexportBtnss(){
            this.ShowAddTemplateDialog = true
        },



        handleShowAddTemplateDialogClose(){
            this.ShowAddTemplateDialog = false
        },


        handleShowAddTemplateDialogSub(){
            this.ShowAddTemplateDialog = false
        },


        searchBtns(){
            this.pageNum = 1
            this.pageSize = 10
            this.handleGeiApiFindOfferPage()
        },

        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.input55 = ''
            this.input6 = ''
            this.input7 = ''
            this.input8 = ''
            this.input9 = []
            this.input6Id = ''
            this.input10 = ''
            this.pageNum = 1
            this.pageSize = 10
            this.handleGeiApiFindOfferPage()
        },

        handleClickView(type,row){
            
            let { resumesId, noteUrl, } = row

            if(type === '详情'){
                this.types = '详情'
                this.initObj = row
                this.resumesId = row.resumesId
                this.currentComponent = 'grantComponents' 
                this.ShowCurrentComponentDialog = true
            }

            if(type === '编辑'){
                this.types = '编辑'
                this.resumesId = row.resumesId
                this.initObj = row
                this.currentComponent = 'grantComponents' 
                this.ShowCurrentComponentDialog = true
                
            }

            if(type == '查看'){
                if(row.noteUrl){
                    let jsonObj = JSON.parse(row.noteUrl)
                    if(this.getFileName(jsonObj.url) === ".pdf"){
                        this.urls = jsonObj.url
                        this.showInfo = true
                    }else if (this.getFileName(jsonObj.url) === ".docx" || this.getFileName(jsonObj.url) === ".doc"){
                        this.docxContent = jsonObj.url 
                        this.showInfos = true
                    }else if (this.getFileName(jsonObj.url) === ".jpg" || this.getFileName(jsonObj.url) === ".png"){
                        this.showImgDingurlsss = jsonObj.url
                        this.showImgDing = true
                    }else{
                       this.$message({type: 'warning', message: '请检查是否为pdf类型简历~' })
                    }
                }
            }

             if(type === '补发'){
                this.ids = String(row.id)
                this.resumesId = row.resumesId
                this.currentComponent = 'followUpComponents' 
                this.ShowCurrentComponentDialog = true
            }

        },

        getFileName(name) {
             return name.substring(name.lastIndexOf("."))
        },

        handleCurrentChange(Current){
            this.pageNum = Current
            this.handleGeiApiFindOfferPage()
        },

        handleSizeChange(Size){
            this.pageSize = Size
            this.handleGeiApiFindOfferPage()
        },


        handleTreeCheck1(e){
            this.input6 = e.deptName
            this.input6Id = e.deptId
            this.$refs.treeSelect.visible = false
        }

    },



}


</script>

<style lang="less" scoped>

    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }

    .box{
        position: fixed;
        background: #f3f3f3;
        width: 100%;
        z-index: 1111;
        top: 0;
        left: 0;
        height: 100vh;
        margin: 0;
    }
    /deep/ .docx-wrapper{
        background:#fff;
    }

    /deep/ .docx-wrapper > section.docx{
        box-shadow: 0 0 #fff;
        width: 100% !important; 
        padding: 0px !important;
    }

    /deep/ .el-form-item__label{
        width: 100px;
    }
    
</style>


// WEBPACK FOOTER //
// src/InterviewManagement/offerFollowUp.vue